<template>

<CrearUsuario></CrearUsuario>

</template>


<script>

import CrearUsuario from '../../components/CrearUsuario.vue';

export default {


 components:{

     CrearUsuario

  }

}


</script>